export const PRODUCT_NAME = 'simpleTour'
export const TOUR = 'tour'
